"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var react_id_generator_1 = tslib_1.__importDefault(require("react-id-generator"));

var Icon_1 = tslib_1.__importDefault(require("../../Icon"));

var styles = tslib_1.__importStar(require("./Statistics.style"));

var ProgressBar_1 = tslib_1.__importDefault(require("./ProgressBar"));

function Statistics(_ref) {
  var reviewScoreCounts = _ref.reviewScoreCounts;
  var reviewScores = [5, 4, 3, 2, 1];
  var total = reviewScores.reduce(function (acc, rating) {
    return acc + reviewScoreCounts[rating];
  }, 0);
  return jsx_runtime_1.jsx("div", {
    children: reviewScores.map(function (score) {
      var count = reviewScoreCounts[score];
      return jsx_runtime_1.jsxs("div", Object.assign({
        css: styles.itemWrapper
      }, {
        children: [jsx_runtime_1.jsx("div", Object.assign({
          css: styles.starWrapper
        }, {
          children: Array(score).fill(0).map(function (_) {
            return jsx_runtime_1.jsx(Icon_1.default, {
              css: styles.star,
              name: "ic_ratingstar_8x8_filled_gray_500"
            }, react_id_generator_1.default());
          })
        }), void 0), jsx_runtime_1.jsx(ProgressBar_1.default, {
          css: styles.progressBar,
          value: count,
          total: total,
          width: "82px"
        }, void 0), jsx_runtime_1.jsx("span", Object.assign({
          css: styles.count
        }, {
          children: "".concat(count, "\uBA85")
        }), void 0)]
      }), score);
    })
  }, void 0);
}

exports.default = react_1.memo(Statistics);